import { render, staticRenderFns } from "./FooterVthree.vue?vue&type=template&id=2ec0d4d5&"
import script from "./FooterVthree.vue?vue&type=script&lang=js&"
export * from "./FooterVthree.vue?vue&type=script&lang=js&"
import style0 from "./FooterVthree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports